import { useCallback, useState } from "react";
import { toast } from "sonner";
import { updateGoal } from "./actions/updateGoal";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import { useApolloClient } from "lib/apollo/client";
import { router } from "@inertiajs/react";
import GoalType from "types/GoalType";
import { insertGoal } from "./actions/insertGoal";
import { GoalSerializersGoalByline } from "types/serializers";

interface Props {
  goal: GoalSerializersGoalByline;
}



export default function useGoal({ goal }: Props) {
  const client = useApolloClient();
  const currentUserId = useCurrentUserId();
  const [loading, setLoading] = useState(false)

  const catchErrorMessage = (error: string) => {
    toast.error(`Something went wrong: ${error}`);
    setLoading(false);
    return error;
  };

  const archive = useCallback(() => {
    // Noop unless the owner
    if (goal?.userId !== currentUserId) {
      return Promise.resolve(goal);
    }

    setLoading(true);
    return updateGoal({
      goal: {
        ...goal as unknown as GoalType,
        ...{ archived: true },
      },
      client,
    }).then(() => {
      router.reload({ only: ["goal", "goals"] });
      setLoading(false);
    }).catch(catchErrorMessage);
  }, [goal]);

  const save = (newGoal: GoalType):Promise<GoalType> => {
    setLoading(false);

    const action = newGoal.id ? updateGoal : insertGoal;

    const promise = action({ goal: newGoal, client })
    
    promise.then(() => {
      setLoading(false);
    }).catch(catchErrorMessage);

    return promise;
  }

  return {
    archive,
    goal,
    loading,
    save,
  };
}
